export default __webpack_public_path__ + "./fonts/ordenes.4d19ec51.svg";